let folderDefine = {};
folderDefine.businessLicense = {};
folderDefine.businessLicense.type = "businessLicense";
folderDefine.businessLicense.typeZh = "三证合一营业执照扫描件";
folderDefine.businessLicense.fp = 1;
folderDefine.businessLicense.customBucket = "enterprise";

folderDefine.basicAccount = {};
folderDefine.basicAccount.type = "basicAccount";
folderDefine.basicAccount.typeZh = "基本户开户许可证扫描件";
folderDefine.basicAccount.fp = 1;
folderDefine.basicAccount.customBucket = "enterprise";

folderDefine.enterpriseOtherFile = {};
folderDefine.enterpriseOtherFile.type = "enterpriseOtherFile";
folderDefine.enterpriseOtherFile.typeZh = "其它";
folderDefine.enterpriseOtherFile.fp = 1;
folderDefine.enterpriseOtherFile.customBucket = "enterprise";

folderDefine.bidProjectInfo = {};
folderDefine.bidProjectInfo.type = "bidProjectInfo";
folderDefine.bidProjectInfo.typeZh = "项目审核";

folderDefine.planSubmit = {};
folderDefine.planSubmit.type = "planSubmit";
folderDefine.planSubmit.typeZh = "项目计划提交";

folderDefine.roomSubmit = {};
folderDefine.roomSubmit.type = "roomSubmit";
folderDefine.roomSubmit.typeZh = "开标室申请提交";

folderDefine.bidSubmit = {};
folderDefine.bidSubmit.type = "tenderNoticeContentPdf";
folderDefine.bidSubmit.typeZh = "招标公告提交";

folderDefine.submitSupplement = {};
folderDefine.submitSupplement.type = "submitSupplement";
folderDefine.submitSupplement.typeZh = "变更公告发布";

folderDefine.submitReviseRequest = {};
folderDefine.submitReviseRequest.type = "submitReviseRequest";
folderDefine.submitReviseRequest.typeZh = "变更公告修正申请单";

folderDefine.openingSubmit = {};
folderDefine.openingSubmit.type = "openingSubmit";
folderDefine.openingSubmit.typeZh = "开标公示提交";

folderDefine.candidateSubmit = {};
folderDefine.candidateSubmit.type = "candidateSubmit";
folderDefine.candidateSubmit.typeZh = "候选人公示提交";

folderDefine.pitchonSubmit = {};
folderDefine.pitchonSubmit.type = "pitchonSubmit";
folderDefine.pitchonSubmit.typeZh = "中标人公示提交";

folderDefine.pitchonNotificationSubmit = {};
folderDefine.pitchonNotificationSubmit.type = "pitchonNotifySubmit";
folderDefine.pitchonNotificationSubmit.typeZh = "中标通知书提交";
folderDefine.pitchonNotificationSubmit.isNeed = 1;

folderDefine.tenderPdf = {};
folderDefine.tenderPdf.type = "tenderPdf";
folderDefine.tenderPdf.typeZh = "招标文件pdf";
folderDefine.tenderPdf.accept = ".pdf";
folderDefine.tenderPdf.fp = 2;
folderDefine.tenderPdf.isNeed = 1;

folderDefine.tenderZbf = {};
folderDefine.tenderZbf.type = "tenderZbf";
folderDefine.tenderZbf.typeZh = "招标文件zbf";
folderDefine.tenderZbf.accept = ".zbf";
folderDefine.tenderZbf.fp = 2;
folderDefine.tenderZbf.isNeed = 1;

folderDefine.tenderZip={};
folderDefine.tenderZip.type="tenderZip";
folderDefine.tenderZip.typeZh="压缩文件";
folderDefine.tenderZip.accept=".zip,.rar";
folderDefine.tenderZip.fp=2;
folderDefine.tenderZip.isNeed=0;

folderDefine.tenderTzp={};
folderDefine.tenderTzp.type="tenderTzp";
folderDefine.tenderTzp.typeZh="图纸文件";
folderDefine.tenderTzp.accept=".tzp";
folderDefine.tenderTzp.fp=2;
folderDefine.tenderTzp.isNeed=0;

folderDefine.tenderXml={};
folderDefine.tenderXml.type="tenderXml";
folderDefine.tenderXml.typeZh="清单文件";
folderDefine.tenderXml.accept=".xml";
folderDefine.tenderXml.fp=2;
folderDefine.tenderXml.isNeed=0;

folderDefine.submitSupplementFile = {};
folderDefine.submitSupplementFile.type = "supplementFile";
folderDefine.submitSupplementFile.typeZh = "变更公告附件";
folderDefine.submitSupplementFile.fp = 2;
folderDefine.submitSupplementFile.isNeed = 1;

folderDefine.submitQuestionFile = {};
folderDefine.submitQuestionFile.type = "questionFile";
folderDefine.submitQuestionFile.typeZh = "质疑质询附件";
folderDefine.submitQuestionFile.fp = 2;
folderDefine.submitQuestionFile.isNeed = 0;

folderDefine.submitObjectionFile = {};
folderDefine.submitObjectionFile.type = "objectionFile";
folderDefine.submitObjectionFile.typeZh = "异议附件";
folderDefine.submitObjectionFile.fp = 2;
folderDefine.submitObjectionFile.isNeed = 0;

folderDefine.submitFailedFile = {};
folderDefine.submitFailedFile.type = "failedFile";
folderDefine.submitFailedFile.typeZh = "招标异常附件";
folderDefine.submitFailedFile.accept=".zip,.rar";
folderDefine.submitFailedFile.fp = 2;
folderDefine.submitFailedFile.isNeed = 0;

folderDefine.submitFailedSign = {};
folderDefine.submitFailedSign.type = "failedSign";
folderDefine.submitFailedSign.typeZh = "招标异常签章";
folderDefine.submitFailedSign.fp = 2;
folderDefine.submitFailedSign.isNeed = 1;

folderDefine.bidApplyFile = {};
folderDefine.bidApplyFile.type = "bidApplyFile";
folderDefine.bidApplyFile.typeZh = "工程建设评定分离项目申请表";
folderDefine.bidApplyFile.fp = 7;
folderDefine.bidApplyFile.customBucket = "ebid-ce";

folderDefine.aliBassFile = {};
folderDefine.aliBassFile.type = "aliBassFile";
folderDefine.aliBassFile.typeZh = "阿里区块链";
folderDefine.aliBassFile.fp = 1;
folderDefine.aliBassFile.customBucket = "ebid-ce";

folderDefine.projectApprovalDoc={};
folderDefine.projectApprovalDoc.type="projectApprovalDoc";
folderDefine.projectApprovalDoc.typeZh="项目审批文件";
folderDefine.projectApprovalDoc.accept=".zip,.rar";
folderDefine.projectApprovalDoc.fp=2;
folderDefine.projectApprovalDoc.isNeed=1;

folderDefine.agentRecordOrEntrust={};
folderDefine.agentRecordOrEntrust.type="agentRecordOrEntrust";
folderDefine.agentRecordOrEntrust.typeZh="代理随机抽取记录或委托合同";
folderDefine.agentRecordOrEntrust.accept=".zip,.rar";
folderDefine.agentRecordOrEntrust.fp=2;
folderDefine.agentRecordOrEntrust.isNeed=1;

folderDefine.tenderBusiLicense={};
folderDefine.tenderBusiLicense.type="tenderBusiLicense";
folderDefine.tenderBusiLicense.typeZh="招标人营业执照";
folderDefine.tenderBusiLicense.accept=".zip,.rar";
folderDefine.tenderBusiLicense.fp=2;
folderDefine.tenderBusiLicense.isNeed=1;

folderDefine.sectionDivideTable={};
folderDefine.sectionDivideTable.type="sectionDivideTable";
folderDefine.sectionDivideTable.typeZh="项目标段划分表";
folderDefine.sectionDivideTable.accept=".zip,.rar";
folderDefine.sectionDivideTable.fp=2;
folderDefine.sectionDivideTable.isNeed=0;

folderDefine.otherSupplement={};
folderDefine.otherSupplement.type="otherSupplement";
folderDefine.otherSupplement.typeZh="其他补充说明材料";
folderDefine.otherSupplement.accept=".zip,.rar";
folderDefine.otherSupplement.fp=2;
folderDefine.otherSupplement.msg="注：可上传进场交易协议、跨区域交易项目的相关决策性文件等。";
folderDefine.otherSupplement.isNeed=0;

// 中标候选人附件zip
folderDefine.candidateAnnexZip={};
folderDefine.candidateAnnexZip.type="candidateAnnexZip";
folderDefine.candidateAnnexZip.typeZh="中标候选人附件";
folderDefine.candidateAnnexZip.accept=".zip,.rar";
folderDefine.candidateAnnexZip.fp=2;
folderDefine.candidateAnnexZip.isNeed=0;

// 中标结果公示附件zip
folderDefine.pitchonAnnexZip={};
folderDefine.pitchonAnnexZip.type="pitchonAnnexZip";
folderDefine.pitchonAnnexZip.typeZh="中标公示附件";
folderDefine.pitchonAnnexZip.accept=".zip,.rar";
folderDefine.pitchonAnnexZip.fp=2;
folderDefine.pitchonAnnexZip.isNeed=0;

// 中标通知书附件zip
folderDefine.notificationAnnexZip={};
folderDefine.notificationAnnexZip.type="notificationAnnexZip";
folderDefine.notificationAnnexZip.typeZh="中标通知书附件";
folderDefine.notificationAnnexZip.accept=".zip,.rar";
folderDefine.notificationAnnexZip.fp=2;
folderDefine.notificationAnnexZip.isNeed=0;

// 人员信息修改附件
folderDefine.personPlanAnnex={};
folderDefine.personPlanAnnex.type="personPlanAnnex";
folderDefine.personPlanAnnex.typeZh="人员修改审核附件";
folderDefine.personPlanAnnex.fp=2;
folderDefine.personPlanAnnex.isNeed=0;


// 人员信息修改附件
folderDefine.extractBidderTrafficway={};
folderDefine.extractBidderTrafficway.type="ExtractBidderTW";
folderDefine.extractBidderTrafficway.typeZh="抽取入围企业签章";
folderDefine.extractBidderTrafficway.fp=2;
folderDefine.extractBidderTrafficway.isNeed=0;


//
folderDefine.remoteEvaluationDoc={};
folderDefine.remoteEvaluationDoc.type="remoteEvaluationDoc";
folderDefine.remoteEvaluationDoc.typeZh="远程异地评标申请表及备案相关佐证材料";
folderDefine.remoteEvaluationDoc.accept=".zip,.rar";
folderDefine.remoteEvaluationDoc.fp=2;
folderDefine.remoteEvaluationDoc.isNeed=1;


folderDefine.reObjectFile = {};
folderDefine.reObjectFile.type = "reObjectFile";
folderDefine.reObjectFile.typeZh = "恢复异议附件";
folderDefine.reObjectFile.fp = 2;
export default {
  folderDefine
}

export {
  folderDefine
}